class CalendlyPopupLinks {
    constructor() {
        this.hashes = new Set(['#book-a-chat', '#get-in-touch', '#book-a-call', '#schedule-a-call']);
        this.selector = 'a[href]';
        this.calendlyUrl = 'https://calendly.com/paulwarren-uk/30min?hide_gdpr_banner=1&background_color=1e3ac2&text_color=ffffff&primary_color=30343c';
        this.scriptSrc = 'https://assets.calendly.com/assets/external/widget.js';
        this.stylesheetHref = 'https://assets.calendly.com/assets/external/widget.css';
        this.onclickValue = 'window.openPwCalendlyPopupWidget(); return false;';
        this.scriptPromise = null;

        window.openPwCalendlyPopupWidget = () => {
            this.openPopup();
            return false;
        };

        this.ensureStylesheet();
        this.ensureScript();
        this.applyToLinks();
        this.observe();
    }

    getHash(link) {
        const href = link.getAttribute('href');

        if (!href) {
            return '';
        }

        try {
            return new URL(href, window.location.href).hash;
        } catch (error) {
            return '';
        }
    }

    isMatch(link) {
        return this.hashes.has(this.getHash(link));
    }

    applyToLinks(root = document) {
        root.querySelectorAll(this.selector).forEach((link) => {
            if (!this.isMatch(link)) {
                return;
            }

            link.setAttribute('onclick', this.onclickValue);
        });
    }

    observe() {
        if (!document.body) {
            return;
        }

        this.observer = new MutationObserver((mutations) => {
            mutations.forEach(({ addedNodes }) => {
                addedNodes.forEach((node) => {
                    if (!(node instanceof HTMLElement)) {
                        return;
                    }

                    if (node.matches(this.selector) && this.isMatch(node)) {
                        node.setAttribute('onclick', this.onclickValue);
                    }

                    this.applyToLinks(node);
                });
            });
        });

        this.observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    ensureStylesheet() {
        if (document.querySelector(`link[href="${this.stylesheetHref}"]`)) {
            return;
        }

        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = this.stylesheetHref;
        document.head.appendChild(stylesheet);
    }

    ensureScript() {
        if (window.Calendly?.initPopupWidget) {
            return Promise.resolve();
        }

        if (this.scriptPromise) {
            return this.scriptPromise;
        }

        this.scriptPromise = new Promise((resolve, reject) => {
            const existingScript = document.querySelector(`script[src="${this.scriptSrc}"]`);

            if (existingScript) {
                existingScript.addEventListener('load', () => resolve(), { once: true });
                existingScript.addEventListener('error', reject, { once: true });
                return;
            }

            const script = document.createElement('script');
            script.src = this.scriptSrc;
            script.async = true;
            script.addEventListener('load', () => resolve(), { once: true });
            script.addEventListener('error', reject, { once: true });
            document.body.appendChild(script);
        });

        return this.scriptPromise;
    }

    async openPopup() {
        try {
            await this.ensureScript();
        } catch (error) {
            return;
        }

        if (!window.Calendly?.initPopupWidget) {
            return;
        }

        window.Calendly.initPopupWidget({
            url: this.calendlyUrl,
        });
    }
}

export { CalendlyPopupLinks as default };
